<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc('edit') }} {{ $tc('refund', 1) }}</div>
      <router-link class="btn-blue" to="refund">{{ $tc('refund', 1) }} {{ $tc('list',2) }}</router-link>
    </div>
    <div class="edit-movie-container">
      <form class="row">
        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.cinema.length > 0 ? 'shift-up' : '' ">{{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('refund_Cinema')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.cinema.length == 0">{{ errmsg }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.screen.length > 0 ? 'shift-up' : '' ">{{ $t('screens') }}</label>
              <b-dropdown :text="selected.screen" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Screen, ScreenIndex) in Screens"
                  @click="onSelectScreen($event, Screen)"
                  :key="ScreenIndex"
                >{{ Screen.screen_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('refund_Screens')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.screen.length == 0">{{ errmsg1 }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.movie.length > 0 ? 'shift-up' : '' ">{{ $tc('movie', 1) }}</label>
              <b-dropdown :text="selected.movie" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Movie, MovieIndex) in Movies"
                  v-on:click="onSelectMovie($event, Movie)"
                  :key="MovieIndex"
                >{{ Movie.movie }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('refund_Movie')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.movie.length == 0">{{ errmsg2 }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.show.length > 0 ? 'shift-up' : '' ">{{ $t('showtime') }}</label>
              <b-dropdown :text="selected.show" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(ScheduleShowTime, ScheduleShowTimeIndex) in ScheduleShowTimes"
                  :key="ScheduleShowTimeIndex"
                  v-on:click="onSelectShow($event, ScheduleShowTime)"
                >{{ ScheduleShowTime.ss_start_date | dateparse }} - {{ ScheduleShowTime.ss_start_show_time }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('refund_showTime')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.show.length == 0">{{ errmsg3 }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selected.refundReason.length > 0 ? 'shift-up' : '' "
              >{{ $t('refundReasons') }}</label>
              <b-dropdown :text="selected.refundReason" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(RefundReason, RefundReasonIndex) in RefundReasons"
                  v-on:click="onSelectRefundReason($event, RefundReason)"
                  :key="RefundReasonIndex"
                >{{ RefundReason.rr_reason }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('refund_RefundReason')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.refundReason.length == 0">{{ errmsg4 }}</span>
          </p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="." type="number" required="required" />
              <label>{{ $t('showCancelReason') }}</label>
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
        </div>-->

        <div class="col-md-4 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  v-model="refundObject.scd_is_active"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >{{ $t('enable') }} {{ $tc('refund', 1) }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import RefundService from "@/services/RefundService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      Cinemas: [],
      Movies: [],
      Screens: [],
      submitted: false,
      errmsg: "",
      errmsg1: "",
      errmsg2: "",
      errmsg3: "",
      errmsg4: "",
      // Saif
      ScheduleShowTimes: [],
      RefundReasons: [],
      selected: {
        cinema: "",
        movie: "",
        screen: "",
        show: "",
        refundReason: ""
      },
      refundObject: {
        cinema_id: null,
        screen_id: null,
        schedule_show_id: null,
        refund_reason_id: null,
        scd_is_active: "Y",
        //
        md_id: null
      },
      // Saif
      checked: "y",
      selectedNewDate: "",
      selecedCinema: ""
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    const { id } = this.$route.query;
    this.getRefundReasonList();
    if (id) {
      this.getRefundDetails(id);
    } else {
      this.$router.go(-1);
    }
    this.getCinemaList();
  },
  mounted() {},
  methods: {
    getRefundDetails: function(scd_id) {
      RefundService.GetRefundById({ scd_id })
        .then(response => {
          const { data } = response;
          console.log("Data : ", data);
          if (data && data.status && data.Records.length > 0) {
            this.refundObject = data.Records[0];
            this.getCinemaList(data.Records[0].cine_id);
            this.selected.cinema = data.Records[0].cine_name;
            this.selected.screen = data.Records[0].screen_name;
            this.selected.refundReason = data.Records[0].rr_reason;
            this.selected.show =
              this.$options.filters.dateparse(data.Records[0].ss_start_date) +
              " - " +
              data.Records[0].ss_start_show_time;
            (this.refundObject["cinema_id"] = data.Records[0].cine_id),
              (this.refundObject["md_id"] = data.Records[0].movie_details_id),
              this.getMoviesList(data.Records[0].movie_details_id);
            // this.getScheduleShowTimes();
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .then(() => {
          this.getScheduleShowTimes();
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getRefundDetails :", error);
        });
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.cinema = x.cine_name;
                this.getActiveScreenByCinemaId(x.cine_id);
              }
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getActiveScreenByCinemaId: function(condition_id) {
      this.Screens = [];
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: condition_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Screens = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getMoviesList: function(md_id) {
      MovieService.GetActiveMoviesWithFormat()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              if (x.md_id === md_id) {
                this.selected.movie = x.movie;
              }
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getRefundReasonList: function() {
      this.RefundReasons = [];
      let payload = {
        tableName: "ms_refund_reasons",
        rr_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RefundReasons = data.Records;
          } else {
            // Shoe Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getScheduleShowTimes: function() {
      let payload = {
        cine_id: this.refundObject.cinema_id,
        movie_details_id: this.refundObject.md_id,
        screen_id: this.refundObject.screen_id
      };
      console.log(
        "object :",
        this.refundObject.cinema_id,
        this.refundObject.md_id,
        this.refundObject.screen_id
      );
      if (
        this.refundObject.cinema_id &&
        this.refundObject.md_id &&
        this.refundObject.screen_id
      ) {
        CinemasService.GetTicketPriceConfiguration(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ScheduleShowTimes = data.Records;
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error:
            console.log(
              "Catch Error on getTicketPriceConfigurationList :",
              error
            );
          });
      }
    },
    onSelectShow: function(event, params) {
      this.selected.show =
        // this.$options.filters.dateparse(params.ss_start_date) +
        // " - " +
        // this.$options.filters.timeparse(
        //   `${params.ss_start_date} ${params.ss_start_show_time}`
        // );
        this.$options.filters.dateparse(params.ss_start_date) +
        " - " +
        params.ss_start_show_time;
      this.refundObject.schedule_show_id = params.ss_id;
    },
    onSelectRefundReason: function(event, params) {
      this.selected.refundReason = params.rr_reason;
      this.refundObject.refund_reason_id = params.rr_id;
    },

    onFinalSubmit: function(redirect) {
      this.submitted = true;
      if (this.refundObject.cinema_id == null) {
        this.errmsg = "Please Select Cinema.";
      }
      if (this.refundObject.screen_id == null) {
        this.errmsg1 = "Please Select Screen.";
      }
      if (this.refundObject.md_id == null) {
        this.errmsg2 = "Please Select Movie.";
      }
      if (this.refundObject.schedule_show_id == null) {
        this.errmsg3 = "Please Select Show Time.";
      }
      if (this.refundObject.refund_reason_id == null) {
        this.errmsg4 = "Please Select Refund Reason.";
      } else {
        this.$validator.validate().then(valid => {
          console.log("Valid :", valid);
          if (valid) {
            this.btenable = true;
            RefundService.UpdateRefund(this.refundObject)
              .then(response => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  if (redirect) {
                    this.$router.push({
                      path: "/cinema-manager/refund"
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RefundComponents/editRefund.vue